import useGetMemberBenefit from "#/components/carrot-plans/hooks/useGetMemberBenefit"
import { UseQueryResult } from "@tanstack/react-query"

export function useCalibratedEngagementEnabled(): UseQueryResult<boolean> {
  return useGetMemberBenefit<boolean>(({ calibratedEngagement }) => !!calibratedEngagement?.enabled)
}
